import type { AuthProps } from 'types/auth';

function isRecord(x: unknown): x is Record<string, unknown> {
  return Boolean(x && typeof x === 'object' && !Array.isArray(x));
}

/**
 * Builds the `user` object stored in auth state from login / token API envelopes
 * where `permissions` and `assignedRole` sit next to `user` under `data`.
 */
export function mergeAuthSnapshotFromEnvelope(envelope: unknown): AuthProps['user'] | null {
  if (!isRecord(envelope)) return null;
  const rawUser = envelope.user;
  if (!isRecord(rawUser)) return null;

  const merged: Record<string, unknown> = { ...rawUser };

  const fromRoot = envelope.permissions;
  const role = envelope.assignedRole;
  const fromRole = isRecord(role) && Array.isArray(role.permissions) ? role.permissions : undefined;

  if (Array.isArray(fromRoot)) {
    merged.permissions = fromRoot;
  } else if (Array.isArray(fromRole)) {
    merged.permissions = fromRole;
  }

  if (isRecord(role)) {
    merged.role = role;
  }

  return merged as AuthProps['user'];
}
